import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string

const STORAGE_KEY = 'sb-auth-token-stringnow'; // garde ta valeur actuelle

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn('Supabase env vars manquantes. Vérifier .env.')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
        auth: {
            // important pour SPA
            persistSession: true,
            autoRefreshToken: true,
            detectSessionInUrl: true,
            flowType: 'pkce',

            // clé de stockage stable → évite les collisions avec d'autres apps
            storageKey: STORAGE_KEY,

            // (optionnel) désactive les logs verbeux
            debug: false,
        },
      })

